// ** MUI Imports
import Card from '@mui/material/Card'
import { useTheme } from '@mui/material/styles'
import CardContent from '@mui/material/CardContent'

// ** Component Import
import { useEffect, useState } from 'react'
import _ from 'lodash'
import { formatNumber } from '../../common/commonFunctions'
import Chart from "react-apexcharts"

interface SummaryPieChartProps {
  title: string,
  summaryChartInfo: {
    labels: any[],
    values: any[],
  }
}

const SummaryPieChart = (props: SummaryPieChartProps) => {

  // ** Hook
  const theme = useTheme()
  const [chartInfo, setChartInfo] = useState<any>(
    {
      options: {},
      values: []
    }
  )

  const { summaryChartInfo, title } = props
  useEffect(() => {
    if (summaryChartInfo && _.isArray(summaryChartInfo.labels) && _.isArray(summaryChartInfo.values))
      setChartInfo({
        options: {
          theme: {
            mode: theme.palette.mode,
          },
          stroke: { width: 0 },
          labels: summaryChartInfo ? summaryChartInfo?.labels : [],
          dataLabels: {
            enabled: true,
            formatter: (val: string) => `${parseInt(val, 10)}%`
          },
          colors: ["#332288", "#6699CC", "#AA4499", "#117733", "#DDCC77", "#2C77FF", "#FF4560", "#546E7A", "#A300D6", "#43BCCD"],
          chart: {
            height: 'auto',
            parentHeightOffset: 0,

          },
          annotations: {
            yaxis: [{
              padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
              }
            }],
            xaxis: [{
              padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
              }
            }],
          },
          title: {
            text: title,
            align: 'left',
            margin: 5,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
              fontSize: '14px',
              fontWeight: '400',
              color: '#1E355E',
            },
          },
          tooltip: {
            x: {
              show: false
            },
            y: {
              formatter: function (value: any) {
                return formatNumber.format(parseInt(value))
              }
            }
          },
          legend: {
            position: 'right',
            itemMargin: {
              horizontal: 0,
              vertical: 2
            },
            offsetX: 0,
            offsetY: 30,
            horizontalAlign: 'center',
            floating: false,
            markers: {
              width: 18,
              height: 18,
              strokeWidth: 0,
              strokeColor: '#fff',
              fillColors: undefined,
              radius: 18,
              customHTML: undefined,
              onClick: undefined,
              offsetX: 0,
              offsetY: 0
            }
          },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: false,
                }
              }
            }
          },
          grid: {
            padding: {
              top: 13,
              right: 0,
              bottom: 0,
              left: 0
            },
          }
        },
        values: summaryChartInfo.values
      })
  }, [summaryChartInfo])



  return (
    <Card className='h-100 p-0'>
      <CardContent style={{ height: '28.5vh' }} className='p-0'>
        <Chart type="pie" height='100%' options={chartInfo.options} series={chartInfo.values} />
      </CardContent>
    </Card>
  )
}

export default SummaryPieChart
